import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Activity } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const BAND_STYLES = {
  GREEN: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Pulse · GREEN' },
  AMBER: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500', label: 'Pulse · AMBER' },
  RED: { bg: 'bg-rose-50', text: 'text-rose-700', dot: 'bg-rose-500', label: 'Pulse · RED' },
  PENDING: { bg: 'bg-slate-100', text: 'text-slate-500', dot: 'bg-slate-400', label: 'Pulse · pending' },
};

/**
 * PulseBadge — public, free badge shown on every listing.
 * Tries cache prop first, otherwise fetches /api/pulse/score/:id.
 */
export const PulseBadge = ({ listingId, score: scoreProp, band: bandProp, compact = false }) => {
  const [data, setData] = useState(scoreProp != null ? { score: scoreProp, band: bandProp } : null);

  useEffect(() => {
    if (data || !listingId) return;
    let cancelled = false;
    axios.get(`${API_URL}/api/pulse/score/${listingId}`)
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch(() => { if (!cancelled) setData({ score: null, band: 'PENDING' }); });
    return () => { cancelled = true; };
  }, [listingId, data]);

  const band = (data?.band || 'PENDING').toUpperCase();
  const styles = BAND_STYLES[band] || BAND_STYLES.PENDING;
  const score = data?.score;

  return (
    <span
      data-testid={`pulse-badge-${listingId}`}
      className={`inline-flex items-center gap-1.5 ${styles.bg} ${styles.text} ${compact ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1 text-xs'} rounded-full font-medium tracking-wide uppercase`}
      title={`Shopperden Pulse: ${score ?? '—'} (${band})`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${styles.dot} animate-pulse`} />
      {compact ? <>P · {score ?? '—'}</> : (
        <>
          <Activity className="h-3 w-3" />
          {styles.label} · {score ?? '—'}
        </>
      )}
    </span>
  );
};

export default PulseBadge;
